import * as Lucide from "lucide-react";

export const Empty = Lucide.createLucideIcon("Empty", []);

export { Empty as default };
